import { Injectable } from '@angular/core';

import { ClientIntake } from '../../models/client-intake';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class ClientIntakeService {
  /**
   * URL for client intakes controller
   * @type {String}
   */
  url: string = 'client_intakes';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Create matter
   * @param  {number} id     Client Intake id
   * @param  {any}    params Params to create matter
   * @return {Promise<any>} Unlock response
   */
  createMatter(id: number, params: any): Promise<any> {
    return this.httpClient.post(`${this.url}/${id}/create_matter.json`, params);
  }

  /**
   * DELETE action for Client Intake resource
   * @param  {number}       id Client Intake id
   * @return {Promise<any>}    Response of destroy
   */
  delete(id: number, deletePermanently: boolean = false): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json${deletePermanently ? '?delete_permanently=1' : ''}`);
  }

  /**
   * EDIT action for Client Intake resource
   * @param  {number}       id Client Intake id
   * @return {Promise<any>}    Response of edit
   */
  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  /**
   * Form default options and select options
   * @return {Promise<any>} Response with form options
   */
  formOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { form_options: true });
  }

  /**
   * INDEX action for Client Intake resource
   * @param  {any       =         {}}        params params for filter if any
   * @return {Promise<any>}           Response with client intakes
   */
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  /**
   * CREATE and UPDATE actions for Client Intake resource
   * @param  {any}          params Client Intake params to be saved
   * @return {Promise<any>} Save response
   */
  save(params: any): Promise<any> {
    if (params.id) return this.httpClient.put(`${this.url}/${params.id}.json`, params);
    else return this.httpClient.post(`${this.url}.json`, params);
  }

  /**
   * Get search select field lists and default options from index action
   * @return {Promise<any>} Response with search options
   */
  searchOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { search_options: true });
  }

  /**
   * SHOW action for Client Intake resource
   * @param  {number}       id Client Intake id
   * @return {Promise<any>}    Response of edit
   */
  show(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`);
  }

  /**
   * Unlock client intake
   * @param  {number} id Client Intake id
   * @return {Promise<any>} Unlock response
   */
  unlock(id: number): Promise<any> {
    return this.httpClient.post(`${this.url}/${id}/unlock.json`, {});
  }
}
